import React from 'react';
import { Link } from 'react-router-dom';
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import './FeaturedEvent.css';

// Import the diplo image
import diploImage from '../assets/eventImages/diplo.jpg';

// Sample featured events by city
const FEATURED_EVENTS = {
  "San Diego": {
    id: "diplos-run-club-san-diego",
    title: "Diplo's Run Club San Diego",
    clubName: "Diplo's Run Club",
    image: diploImage,
    date: "Saturday, Nov 8th, 2025",
    time: "7:00 AM",
    location: "Gallagher Square, Petco Park",
    distance: "5K",
    description:
      "For the first time ever, Diplo's Run Club is hitting the streets of San Diego, California!",
    tags: ["Festival", "Live Music", "Downtown", "5K"],
    instagram: "https://www.instagram.com/diplosrunclub/",
    registration: "https://diplosrunclub.com/san-diego",
    contact: "info@diplosrunclub.com"
  },
  "San Francisco": {
    id: "diplos-run-club-san-francisco",
    title: "Diplo's Run Club San Francisco",
    clubName: "Diplo's Run Club",
    image: diploImage,
    date: "11th October 2025",
    time: "7:00 AM",
    location: "Robin Williams Meadow at Golden Gate Park",
    distance: "5K",
    description:
      "Diplo's Run Club is returning to the Bay Area for round two!",
    tags: ["Festival", "Live Music", "Waterfront", "5K"],
    instagram: "https://www.instagram.com/diplosrunclub/",
    registration: "https://diplosrunclub.com/san-francisco",
    contact: "info@diplosrunclub.com"
  }
};


function FeaturedEvent({ city }) {
  const event = FEATURED_EVENTS[city];

  if (!event) {
    return null; // Don't render if no featured event for this city
  }

  const citySlug = city.toLowerCase().replace(' ', '-');
  const eventLink = `/events/${citySlug}/${event.id}`;

  return (
    <div className="featured-event">
      <div className="featured-event-header">
        <h3>🌟 Featured Event in {city}</h3>
      </div>
      
      <div onClick={() => window.location.href = eventLink} className="featured-event-card">
        <div className="featured-event-image">
          <img src={event.image} alt={event.title} />
        </div>
        
        <div className="featured-event-content">
          <div className="event-club">{event.clubName}</div>
          <h4 className="event-title">{event.title}</h4>
          <p className="event-description">{event.description}</p>
          
          

        </div>
      </div>
    </div>
  );
}

export default FeaturedEvent; 